module.exports = __webpack_public_path__ + "img/v-fd-his.3d1bfa73.svg";